import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'

export const Tatari: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: '',
  },

  initialize: async () => {
    await initializeScript({
      key: 'tatari',
      domain: '',
      path: '',
      init: () => {
        ;(function () {
          try {
            ;(function (t, i) {
              if (!i.version) {
                ;(window.tatari = i),
                  (i.init = function (t: unknown, n: unknown) {
                    const e = function (t: unknown, n: unknown) {
                      i[n] = function (...args: unknown[]) {
                        t.push([n].concat(args))
                      }
                    }
                    'track pageview identify'.split(' ').forEach(function (t) {
                      e(i, t)
                    })
                    i._i = t as string
                    i.config = n
                    i.pageview?.()
                  }),
                  (i.version = '1.2.1')
                const n = t.createElement('script')
                ;(n.type = 'text/javascript'),
                  (n.async = !0),
                  (n.src =
                    'https://d2hrivdxn8ekm8.cloudfront.net/tag-manager/26f5b6f1-5fab-481a-8824-5ff817ec519f-latest.js')
                const e = t.getElementsByTagName('script')[0]
                e?.parentNode?.insertBefore(n, e)
              }
            })(document, window.tatari ?? [])
          } catch (t) {
            console.log(t)
          }
        })()
        window.tatari?.init?.('26f5b6f1-5fab-481a-8824-5ff817ec519f')
      },
    })
  },

  events: {},
}
